import CompanyClientsListContent from "../../features/companyClients/widgets/CompanyClientsListContent";

function CompanyClientsListScreen() {
  return <CompanyClientsListContent />;
}

export default CompanyClientsListScreen;
